<template>
  <v-dialog v-model="dialog" max-width="360">
    <template v-slot:activator="{ on, attrs }">
      <v-btn small v-bind="attrs" v-on="on">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on">mdi-close-outline</v-icon>
          </template>
          <span>{{ $t("cancelWithdraw") }}</span>
        </v-tooltip>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dense>
        <v-toolbar-title>{{ $t("cancelWithdraw") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-form ref="form">
        <v-card-text class="mt-3 text-center">
          <div class="text-left">
            <div class="subtitle-1 pt-3">
              <strong>{{ $t("withdrawalID") }}: {{ id_withdraw }}</strong>
            </div>
            <div class="subtitle-1 mb-4">
              <span>{{ $t("value") }}:</span>
              <span class="red--text pl-2"
              ><strong>{{ value_requested }}</strong></span
              >
            </div>
            <div class="">
              <span>{{ $t('user') }}: {{ user_name }}</span>
            </div>
            <div class="mb-4" style="width: 50%">
              {{ $t("entryDate") }}: {{ register_date }}
            </div>
            <div class="mb-1" style="font-size: 12px">
              {{ $t("adviseCancelWithdraw") }}
            </div>
          </div>
          <div>
            <v-select
              v-model="select"
              :items="messages"
              dense
              outlined
              :disabled="disabled"
            ></v-select>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            :disabled="disabled"
            class="ma-1 info"
            @click.prevent="cancelWithdraw()"
            >{{ $t("toConfirm") }}</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "cancelWithdraw",
  props: ["id_withdraw", "value_requested", "register_date", "user_name"],
  data: () => ({
    dialog: false,
    loading: false,
    disabled: false,
    select: {},
  }),
  computed: {
    messages() {
      return [
        {
          text: this.$t('requestedByCustumer'),
          value: this.$t('requestedByCustumer')
        },
        {
          text: this.$t('reason2'),
          value: this.$t('reason2')
        },
        {
          text: this.$t('reason3'),
          value: this.$t('reason3')
        },
      ]
    }
  },
  mounted(){
    this.select = this.messages[0].value
  },
  methods: {
    cancelWithdraw() {
      this.loading = true;
      this.disabled = true;
      const body = {
        withdraw_id: this.id_withdraw,
        reason: this.select,
      };
      this.$axios
        .post("/administrator/bankOnline/cancelWithdraw", this.$formdata(body))
        .then((response) => {
          this.$store.commit("setFeedbackSnack", {
            msg: response.data.messages,
            color: "success",
          });
          this.dialog = false;
          this.refreshList(this.id_withdraw);
        })
        .catch((error) => {
          console.log(error);
        }).finally(() => {this.loading = false; this.disabled = false;});
    },
    refreshList(id_withdraw){
      this.$emit('refresh-list', id_withdraw)
    }
  },
};
</script>
